import React from "react"
import { FormattedMessage } from "react-intl"

export const PRODUCT_QOH_ADJUSTMENT_SUCCESSFUL_MESSAGE = <FormattedMessage
    key="inventory.components.product_inventory_quantities_listing.productQohAdjustmentSuccessful"
    id="inventory.components.product_inventory_quantities_listing.productQohAdjustmentSuccessful"
    defaultMessage="Stock document creation successful"
/>


// WEBPACK FOOTER //
// ./src/utils/product/utils.tsx